// import React from 'react'; //, useContext, useEffect 
import '../css/stagedetail.scss';
import type {IStage} from '../interfaces/IStage';

interface IProps {
    stage: IStage;
}

const StageDetail = ({ stage }: IProps) => {
    return (
        <div id="stage-detail">
            {
                stage.isCancelled ?
                    <h1 className="cancelled">ANNULÉ</h1> :
                    <></>
            }
            <div className={`${stage.isCancelled ? 'strikethrough' : ''}`}>

                <h2>{stage.title}</h2>
                {(stage.statut && stage.statut === 'confirmed')
                    ? <h3 className='status'>Stage confirmé</h3> : <h5>Stage confirmé dès 8 inscrits</h5>
                }

                <h3>{stage.date}</h3>
                <p>{stage.accroche}<span role="img" aria-label="stars">✨</span></p>
                <img className="big" src={stage.img} alt="aérien" />

                <p><b>Pour qui ?</b><br />
                    {stage.texte}
                    {/* Ce stage proposera une découverte des différentes disciplines de cirque le matin et l'après-midi sera consacré à une initiation à l'aérien  (trapèze, tissu, cerceau).<br />
                    Ce stage n'est pas une spécialisation pour des élèves ayant déjà pratiqué l'aérien. Ils sont néanmoins les bienvenus et des exercices leur seront proposés en fonction de leur niveau.<br />
                    Celui-ci est destiné aux enfants à partir de 6 ans qui désirent découvrir le monde du cirque et des joies de se mettre la tête en bas pour la première fois.<br />
                    Les enfants auront l'opportunité de développer leur agilité, leur créativité et leur confiance en soi tout en s'amusant !<br />
                    En plus de développer des compétences physiques, nos stages encouragent également le travail d'équipe, la concentration et la discipline, des valeurs essentielles pour la vie quotidienne. */}
                </p>
                <h4>{stage.qui}</h4>

                <p><b>Lieu :</b> Salle 2 de l'Institut Sainte-Marie <br />
                    227, rue de l'Aurore à 5100 Jambes</p>
                <p><b>Horaires :</b>  De 9h à 16h</p>
                <p><b>Prix :</b> {stage.prix}€<br />
                    ({stage.prix_detail}).</p>
                <p><b>Infos et réservations :</b> Envoyer un mail à : <a href="mailto:creacirque@gmail.com" title="Mail Creacirque">creacirque@gmail.com</a></p>
            </div>
        </div>
    )
}

export default StageDetail;
